import { defineComponent as _defineComponent } from 'vue'
import { mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent } from "vue"


import { ref, watch, computed } from 'vue'
import cosRangePickerProps from '../cosRangePicker'
import CosInputView from '@/components/Antd/CosView/input.vue'
import dayjs from 'dayjs'
import { toBeijingTime } from '@/utils/timeFormat'
const __default__ = { name: 'CosRangePicker' }

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  props: cosRangePickerProps(),
  emits: ['update:startTime', 'update:endTime', 'change'],
  setup(__props, { emit: __emit }) {

const props = __props
const emit = __emit
const time = ref<any[]>([])
const resultTime = ref<any[]>([])
watch(
  () => props.startTime,
  (v, prev) => {
    if (v !== resultTime.value[0]) {
      if (v && props.endTime) {
        time.value = [v, props.endTime]
      } else {
        time.value = []
      }
    }
  },
  { immediate: true }
)
const viewVal = computed(() => {
  const valueFormat = props.valueFormat ? props.valueFormat : props.showTime ? 'YYYY/MM/DD HH:mm:ss' : 'YYYY/MM/DD'
  let result = ''
  if (props.startTime) {
    result += dayjs(props.startTime).format(valueFormat)
  }
  if (props.endTime) {
    result += ' - ' + dayjs(props.endTime).format(valueFormat)
  }
  if (!result) {
    result = '--'
  }
  return result
})
const formFormat = computed(() => {
  return props.valueFormat ? props.valueFormat : props.showTime ? 'YYYY/MM/DD HH:mm:ss' : 'YYYY/MM/DD'
})
const change = () => {
  let startTime = ''
  let endTime = ''
  const format = props.valueFormat || 'YYYY/MM/DD'
  if (time.value && time.value.length) {
    startTime = time.value[0]
    endTime = time.value[1]
    if (props.autoTime && !props.showTime) {
      startTime = dayjs(startTime).format(format) + ' 00:00:00'
      endTime = dayjs(endTime).format(format) + ' 23:59:59'
    }
  }
  // 默认为电脑本地时间，如果需要转换为北京时间，需要传入isOutputBeijingTime
  startTime = startTime && props.isOutputBeijingTime ? toBeijingTime(startTime, `${format} HH:mm:ss`) : startTime
  endTime = endTime && props.isOutputBeijingTime ? toBeijingTime(endTime, `${format} HH:mm:ss`) : endTime
  resultTime.value = [startTime, endTime]
  emit('update:startTime', startTime)
  emit('update:endTime', endTime)
  emit('change')
}

return (_ctx: any,_cache: any) => {
  const _component_a_range_picker = _resolveComponent("a-range-picker")!

  return (_ctx.view)
    ? (_openBlock(), _createBlock(CosInputView, _mergeProps({ key: 0 }, _ctx.$attrs, { value: viewVal.value }), null, 16, ["value"]))
    : (_openBlock(), _createBlock(_component_a_range_picker, _mergeProps({
        key: 1,
        style: {"width":"100%"},
        value: time.value,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((time).value = $event))
      }, _ctx.$attrs, {
        valueFormat: formFormat.value,
        showTime: _ctx.showTime,
        onChange: change
      }), null, 16, ["value", "valueFormat", "showTime"]))
}
}

})